/**
 * Single source-of-truth for classifying an event as upcoming / past / draft.
 *
 * Rules (uses exact timestamps, NOT day-truncated):
 *  1. No startDate → "draft"
 *  2. Has endDate → PAST when end <= now, else UPCOMING
 *  3. No endDate  → PAST when start <= now, else UPCOMING
 */

export type EventTimeBucket = 'upcoming' | 'past' | 'draft';

export interface TimeBucketResult {
  bucket: EventTimeBucket;
  label: string;
}

const LABELS: Record<EventTimeBucket, string> = {
  upcoming: 'Kommande',
  past: 'Passerad',
  draft: 'Utkast',
};

export function getEventTimeBucket(
  event: { startDate?: string | null; endDate?: string | null; start_date?: string | null; end_date?: string | null },
  now: Date = new Date(),
): TimeBucketResult {
  // Support both camelCase and snake_case field names
  const startRaw = event.startDate ?? event.start_date;
  const endRaw = event.endDate ?? event.end_date;

  if (!startRaw) {
    return { bucket: 'draft', label: LABELS.draft };
  }

  const cutoff = endRaw ? new Date(endRaw) : new Date(startRaw);
  const bucket: EventTimeBucket = cutoff <= now ? 'past' : 'upcoming';

  return { bucket, label: LABELS[bucket] };
}
